import React from "react";
import AlarmForm from "./AlarmForm";

const CreateAlarm = () => {
  return <AlarmForm />;
};

export default CreateAlarm;
